export default function getUrl() {
    let url = "";
    if (process.env.NODE_ENV === "development") url = "https://localhost:64343/";
    else if (process.env.NODE_ENV === "production") {
      url = "https://api.dhtr.pk/";
      //url = "https://devapi.dhtr.pk/";
    }
    return url;
  };